import { render, staticRenderFns } from "./create-project.vue?vue&type=template&id=b85c997a&scoped=true"
import script from "./create-project.vue?vue&type=script&lang=ts"
export * from "./create-project.vue?vue&type=script&lang=ts"
import style0 from "./create-project.vue?vue&type=style&index=0&id=b85c997a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85c997a",
  null
  
)

export default component.exports